import { useQuery } from '@tanstack/react-query';
import { getRakeAgentStats } from '../rake.service';
import { UseQueryResult } from '@tanstack/react-query/build/modern';
import { AgentRakeStats } from '@/services/rake/rake.types';

interface useGetAgentRakeStatsResult {
  data: AgentRakeStats;
}
const useGetAgentRakeStats = (): UseQueryResult<useGetAgentRakeStatsResult, Error> => {
  return useQuery<useGetAgentRakeStatsResult, Error>({
    queryKey: ['rake-agent-stats'],
    queryFn: getRakeAgentStats,
  });
};

export default useGetAgentRakeStats;
